import styled from 'styled-components';
import { InverseClearButton } from '#/shared/components/Styled';
import BaseTripButton from '#/shared/components/Styled/TripButton';
import BaseEmailIcon from '#/shared/components/GeneratedIcons/trimet/Email';
import { GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import GTM_HANDLES from '#/shared/gtm-handles';

export const AlertsPreviewWrapper = styled.div`
  border-radius: 5px;
  padding: 8px;
  background-color: ${props => props.theme.inverseBackgroundColor3};
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${props => props.theme.inverseFontColor1};
  flex-direction: row;
`;

export const AlertsPreviewTitleButton = styled(InverseClearButton).attrs({
  [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.route.routeAlertsPreviewButton,
})`
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 5px 10px;
`;

export const AlertsPreviewTitleColumn = styled.div`
  padding-left: 5px;
  font-size: 16px;
`;

export const EmailIcon = styled(BaseEmailIcon).attrs(props => ({
  width: 15,
  height: 15,
  fill: props.theme.inverseFontColor1,
  role: 'presentation',
}))`
  flex: 0 0 20px;
  margin-right: 5px;
  padding-bottom: 2px;
`;

export const AlertsPreviewEmailButton = styled(BaseTripButton).attrs({
  [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.route.routeAlertsByEmailButton,
})`
  border-radius: 5px;
  display: flex;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  padding: 5px;
`;

export const AlertsPreviewEmailButtonText = styled.div`
  flex: 1 1 auto;
  padding: 0 5px;
  text-align: left;
`;

export const AlertsPreviewEmailButtonIcon = styled.div`
  flex: 0 0 auto;
  padding: 0 5px;
  border-radius: 5px;
  display: flex;
`;
